{
  "blocks": [
    {
      "id": "proc-embryo-culture",
      "kind": "procedure",
      "tags": ["ivf", "lab", "both-partners"],
      "title": "Embryo Culture",
      "subtitle": "Growing embryos in the lab from fertilization to blastocyst stage",
      "body": {
        "procedureName": "Embryo Culture",
        "category": "lab",
        "description": "Growing embryos in the lab from fertilization to Day 5-7 blastocyst stage.",
        "howItWorks": "Fertilized eggs (zygotes) are placed in specialized culture media in incubators that mimic the conditions of the fallopian tube and uterus. Embryologists monitor development at key checkpoints: Day 1 (fertilization check), Day 3 (6-8 cells), Day 5-6 (blastocyst). Not all fertilized eggs make it: typically 30-50% of fertilized eggs reach the blastocyst stage. Time-lapse imaging allows continuous monitoring without disturbing the embryos.",
        "duration": "5-7 days",
        "whatToExpect": [
          "Daily updates from your clinic on embryo progress",
          "Some attrition is normal, not all embryos will make it",
          "Day 3 update: cell count and grade",
          "Day 5-6 update: which embryos reached blastocyst",
          "Final count of embryos available for transfer/freezing/biopsy"
        ],
        "results": [
          {
            "label": "Day 3 update",
            "detail": "Some clinics share cell count and grade around Day 3, while others wait until blastocyst stage."
          },
          {
            "label": "Day 5-7 update",
            "detail": "The key result is how many embryos reached blastocyst and are available for transfer, freezing, or biopsy."
          },
          {
            "label": "Why counts change",
            "detail": "Attrition is expected. The number of fertilized eggs, growing embryos, blastocysts, and usable embryos can all be different."
          }
        ],
        "forWhom": "both",
        "frBody": {
          "procedureName": "Culture embryonnaire",
          "description": "Mise en culture des embryons au laboratoire, de la fécondation au stade blastocyste (J5–J7).",
          "howItWorks": "Les ovocytes fécondés (zygotes) sont placés dans des milieux de culture spécialisés au sein d'incubateurs qui reproduisent les conditions des trompes et de l'utérus. Les embryologistes contrôlent le développement à des étapes clés : J1 (contrôle de fécondation), J3 (6-8 cellules), J5-J6 (blastocyste). Tous les ovocytes fécondés n'évoluent pas : généralement 30 à 50 % atteignent le stade blastocyste. L'imagerie en time-lapse permet un suivi continu sans perturber les embryons.",
          "duration": "5 à 7 jours",
          "whatToExpect": [
            "Comptes rendus quotidiens de votre centre sur l'évolution des embryons",
            "Une attrition est normale ; tous les embryons n'évoluent pas",
            "Point J3 : nombre de cellules et grade",
            "Point J5-J6 : embryons ayant atteint le stade blastocyste",
            "Bilan final : embryons disponibles pour transfert, congélation ou biopsie"
          ],
          "results": [
            {
              "label": "Point J3",
              "detail": "Certains centres communiquent le nombre de cellules et le grade vers J3, tandis que d'autres attendent le stade blastocyste."
            },
            {
              "label": "Point J5-J7",
              "detail": "Le résultat clé est le nombre d'embryons ayant atteint le stade blastocyste et disponibles pour transfert, congélation ou biopsie."
            },
            {
              "label": "Pourquoi les nombres changent",
              "detail": "Une attrition est attendue. Le nombre d'ovocytes fécondés, d'embryons en développement, de blastocystes et d'embryons utilisables peut être différent."
            }
          ]
        }
      },
      "sources": [
        {
          "title": "Good practice recommendations on add-ons in reproductive medicine",
          "authors": "ESHRE Add-ons working group; Lundin K, Bentzen JG, et al.",
          "journal": "Human Reproduction",
          "year": 2023,
          "url": "https://pubmed.ncbi.nlm.nih.gov/37747409/",
          "evidenceLevel": "guideline"
        },
        {
          "title": "Treatment add-ons with limited evidence",
          "authors": "Human Fertilisation and Embryology Authority",
          "journal": "HFEA",
          "year": 2023,
          "url": "https://www.hfea.gov.uk/treatments/treatment-add-ons/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
